import {useQuery, useMutation, useQueryClient} from '@tanstack/vue-query';
import axios from 'axios';

const QUERY_KEY = ['admin', 'banners'];

export const useAdminBanners = () => useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
        const {data} = await axios.get('/ajax/v2/admin/banners');
        return data.data;
    },
});

export const useCreateBanner = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload) => axios.post('/ajax/v2/admin/banners', payload),
        onSuccess: () => queryClient.invalidateQueries({queryKey: QUERY_KEY}),
    });
};

export const useUpdateBanner = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({id, payload}) => {
            if (payload instanceof FormData) {
                payload.append('_method', 'PATCH');

                return axios.post(`/ajax/v2/admin/banners/${id}`, payload);
            }

            return axios.patch(`/ajax/v2/admin/banners/${id}`, payload);
        },
        onSuccess: () => queryClient.invalidateQueries({queryKey: QUERY_KEY}),
    });
};

export const useDeleteBanner = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => axios.delete(`/ajax/v2/admin/banners/${id}`),
        onSuccess: () => queryClient.invalidateQueries({queryKey: QUERY_KEY}),
    });
};

export const useUploadBannerImage = () => {
    return useMutation({
        mutationFn: ({id, size, formData}) =>
            axios.post(`/ajax/v2/admin/banners/${id}/image/${size}`, formData, {
                headers: {'Content-Type': 'multipart/form-data'},
            }),
    });
};

export const useDeleteBannerImage = () => {
    return useMutation({
        mutationFn: ({id, size}) => axios.delete(`/ajax/v2/admin/banners/${id}/image/${size}`),
    });
};
